<template>
    <section class="p-3 bg-white border-light">
        <a
            class="font-weight-bold float-right "
            :class="canEditStaff ? 'text-primary cursor-pointer' : 'text-muted cursor-not-allowed'"
            @click="canEditStaff ? editProfile() : null"
            >Edit</a
        >
        <div class="row">
            <div class="col-3">
                <img
                    class="img-fluid mr-2 profile-image"
                    :src="
                        person.profile_photo_url
                            ? person.profile_photo_url
                            : '../../../images/default_therapist.jpeg'
                    "
                />
            </div>
            <div class="col-9 d-flex flex-column justify-content-center">
                <h5 class="mb-0 text-uppercase font-weight-bold">{{ person.name }}</h5>
                <p class="mb-0 font-weight-bold">goLOTUS ID: {{ id }}</p>
                <p class="mb-0">
                    <span class="font-weight-bold">Date of birth: </span
                    >{{ therapist.dob ? moment(therapist.dob).format("MM/DD/YYYY") : "" }}
                </p>
                <p class="mb-0">
                    <span class="font-weight-bold">Gender: </span>{{ therapist.gender }}
                </p>
            </div>
        </div>
        <p class="mb-0"><span class="font-weight-bold">E-mail: </span>{{ person.email }}</p>
        <p class="mb-0">
            <span class="font-weight-bold">Work phone: </span
            >{{ helpers.formatPhone(therapist.work_phone) }}
        </p>
        <p class="mb-0">
            <span class="font-weight-bold">Home phone: </span
            >{{ helpers.formatPhone(therapist.home_phone) }}
        </p>
        <p class="mb-0">
            <span class="font-weight-bold">Mobile phone: </span
            >{{ helpers.formatPhone(therapist.mobile_phone) }}
        </p>
        <p class="mb-0">
            <span class="font-weight-bold">Social Security Number: </span>{{ therapist.ssn }}
        </p>
        <template v-for="(a, i) in therapist.addresses">
            <p class="mb-1 font-weight-bold">{{ i ? `Address #${i + 1}` : `Home Address` }}:</p>
            <p class="mb-0">{{ a.address1 }}</p>
            <p class="mb-0">{{ a.address2 }}</p>
            <p class="mb-0">{{ a.city }} {{ a.state }} {{ a.zip }}</p>
        </template>
        <modal-component
            :id="'therapist-profile'"
            :title="modal.title"
            :visible="modal.visible"
            @close="resetModal()"
        >
            <form class="p-3">
                <div class="form-group row">
                    <label for="first_name" class="col-6 mb-1">First name:</label>
                    <div class="col-6">
                        <input
                            id="first_name"
                            type="text"
                            class="form-control form-control-sm"
                            v-model="payload.first_name"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="last_name" class="col-6 mb-1">Last name:</label>
                    <div class="col-6">
                        <input
                            id="last_name"
                            type="text"
                            class="form-control form-control-sm"
                            v-model="payload.last_name"
                        />
                    </div>
                </div>
                <div class="form-group row mb-1">
                    <label for="dob" class="col-6 mb-1">Date of Birth:</label>
                    <div class="col-6">
                        <v-date-picker
                            class="form-control form-control-sm"
                            v-model="payload.dob"
                        ></v-date-picker>
                    </div>
                </div>
                <div class="form-group row mb-1">
                    <label for="ssn" class="col-6 mb-1">Social Security Number:</label>
                    <div class="col-6">
                        <input
                            id="ssn"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Social Security Number"
                            v-mask="'###-##-####'"
                            v-model="payload.ssn"
                        />
                    </div>
                </div>
                <div class="form-group row mb-1">
                    <label for="gender" class="col-6 mb-1">Gender:</label>
                    <div class="col-6">
                        <select
                            v-model="payload.gender"
                            id="gender"
                            class="form-control form-control-sm"
                            required
                        >
                            <option selected disabled :value="null">Please choose one</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row mb-1">
                    <label for="work_phone" class="col-6 mb-1">Work phone:</label>
                    <div class="col-6">
                        <input
                            id="work_phone"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Work phone"
                            v-mask="'(###) ###-#### ####'"
                            v-model="payload.work_phone"
                        />
                    </div>
                </div>
                <div class="form-group row mb-1">
                    <label for="home_phone" class="col-6 mb-1">Home phone:</label>
                    <div class="col-6">
                        <input
                            id="home_phone"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Home phone"
                            v-mask="'(###) ###-#### ####'"
                            v-model="payload.home_phone"
                        />
                    </div>
                </div>
                <div class="form-group row mb-1">
                    <label for="mobile_phone" class="col-6 mb-1">Mobile phone:</label>
                    <div class="col-6">
                        <input
                            id="mobile_phone"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Mobile phone"
                            v-mask="'(###) ###-#### ####'"
                            v-model="payload.mobile_phone"
                        />
                    </div>
                </div>
                <template v-for="(a, i) in payload.addresses">
                    <p class="mb-1 font-weight-bold">
                        {{ i ? `Address #${i + 1}` : `Home Address` }}:
                    </p>
                    <div class="form-group row mb-0">
                        <label for="address1" class="col-6 mb-1">Address 1:</label>
                        <div class="col-6">
                            <input
                                id="address1"
                                type="text"
                                class="form-control form-control-sm"
                                v-model="a.address1"
                            />
                        </div>
                    </div>
                    <div class="form-group row mb-0">
                        <label for="address2" class="col-6 mb-1">Address 2:</label>
                        <div class="col-6">
                            <input
                                id="address2"
                                type="text"
                                class="form-control form-control-sm"
                                v-model="a.address2"
                            />
                        </div>
                    </div>
                    <div class="form-group row mb-0">
                        <label for="city" class="col-6 mb-1">City:</label>
                        <div class="col-6">
                            <input
                                id="city"
                                type="text"
                                class="form-control form-control-sm"
                                v-model="a.city"
                            />
                        </div>
                    </div>
                    <div class="form-group row mb-0">
                        <label for="state" class="col-6 mb-1">State/Zip:</label>
                        <div class="col-6">
                            <input
                                id="state"
                                v-mask="'AA'"
                                type="text"
                                class="form-control form-control-sm col-4 mb-1"
                                v-model="a.state"
                            />
                            <input
                                id="zip"
                                v-mask="'#####-####'"
                                type="text"
                                class="form-control form-control-sm col-6 mb-1"
                                v-model="a.zip"
                            />
                        </div>
                    </div>
                </template>

                <div class="d-flex justify-content-end">
                    <button
                        class="btn btn-sm btn-primary text-white"
                        @click.prevent="saveProfile()"
                    >
                        Save
                    </button>
                </div>
            </form>
            <errors :errors="errors"></errors>
        </modal-component>
        <signature :user="person" :canvas-id="'therapist-profile-signature'"></signature>
    </section>
</template>
<script>
import ModalComponent from "../ui/ModalComponent";
import Signature from "../ui/Signature.vue";
import { helpers } from "../../plugins/helpers";
import { permissions } from "../../plugins/permissions";
import { errors } from "../../plugins/errors";

export default {
    name: "TherapistProfile",
    components: {
        Signature,
        ModalComponent,
    },
    props: [
        "organization",
        "canEditUser",
        "canEditTherapist",
        "person",
        "therapist",
        "id",
        "supervisors",
    ],
    mixins: [permissions, errors],
    data() {
        return {
            helpers,
            modal: {
                visible: false,
                title: "Edit Therapist Profile",
            },
            payload: this.generatePayload(),
        };
    },

    methods: {
        generatePayload() {
            return {
                first_name: null,
                last_name: null,
                dob: null,
                ssn: null,
                gender: null,
                work_phone: null,
                home_phone: null,
                mobile_phone: null,
                addresses: [],
                supervisor_user_id: null,
            };
        },

        editProfile() {
            this.payload.first_name = this.person.first_name;
            this.payload.last_name = this.person.last_name;
            this.payload.dob = this.therapist.dob ? this.moment(this.therapist.dob).toDate() : null;
            this.payload.ssn = null;
            this.payload.gender = this.therapist.gender;
            this.payload.work_phone = this.therapist.work_phone;
            this.payload.home_phone = this.therapist.home_phone;
            this.payload.mobile_phone = this.therapist.mobile_phone;
            this.payload.supervisor_user_id = this.therapist.supervisor_user_id;
            this.payload.addresses = [...this.therapist.addresses];
            if (!this.payload.addresses.length) {
                this.payload.addresses.push({
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zip: null,
                });
            }
            this.modal.visible = true;
        },

        resetModal() {
            this.modal.visible = false;
            this.payload = this.generatePayload();
            this.setErrors();
        },

        saveProfile() {
            this.setErrors();
            let payload = { ...this.payload };
            if (!payload.ssn || payload.ssn.includes("*")) delete payload.ssn; //Removes empty or unchanged SSN to prevent masked value from being saved
            payload.dob = payload.dob ? this.moment(payload.dob).format("YYYY-MM-DD") : null;
            axios
                .patch(
                    `/api/organizations/${this.organization.id}/therapists/${this.therapist.id}`,
                    payload
                )
                .then(r => {
                    this.resetModal();
                    this.$emit("data-saved");
                })
                .catch(e => {
                    console.error(e);
                    this.setErrors(_.get(e, "response.data.errors", {}));
                });
        },
    },
};
</script>

<style scoped></style>
